import { parseTelemetryEnv } from '@lunacast/lib-telemetry';
import type { TelemetryInitOptions } from '@lunacast/lib-telemetry';

const telemetryEnv = parseTelemetryEnv(
  import.meta.env as Record<string, string | undefined>,
);

/** admin-web 루트 `TelemetryPageTracker`에 넘기는 계측 초기화 옵션이다. */
export const telemetryInitOptions: TelemetryInitOptions = {
  enabled: telemetryEnv.enabled,
  connectionString: telemetryEnv.connectionString,
  clarityProjectId: telemetryEnv.clarityProjectId,
  cloudRoleName: 'admin-web',
};
